// AI Tutor thinking presentation (doc 27, ST-02) -- which status is TRUE.
//
// Four phases, each backed by a real signal and nothing else (doc 27 §14,
// §28.1 R3). Routing, retrieval, planning and judging emit no event, so no
// phase names them.
//
//   reconnecting  the event stream's transport is reconnecting (store
//                 `streamStatus`) while a reply is awaited
//   preparing     the server said so: SSE `state` with `state: 'preparing'`
//                 or `state: 'answering'`
//   image         the message being answered carries a photo
//   question      a send is in flight and none of the above holds
//
// AT-API-020-H1 (AT-API-020-SUP-5: the state -> phase map only; copy, timings
// and reveal are unchanged). API 0.2.0 reports four stages of a turn:
//
//   reading    the Tutor is reading the message (and its photo): no phase of
//              its own -- the status stays what the message itself says,
//              `image` for a photo and `question` otherwise
//   preparing  -> `preparing`
//   answering  -> `preparing`, as before: the words follow at once, and the
//              first of them replaces the status
//   recording  the reply's text is complete; nothing is "thinking" any more,
//              so it selects no status
export const THINKING_PHASE = Object.freeze({
  QUESTION: 'question',
  IMAGE: 'image',
  PREPARING: 'preparing',
  RECONNECTING: 'reconnecting',
})

/**
 * @param {Object} input
 * @param {string} [input.streamStatus] store `aiTutor.streamStatus`
 * @param {import('@/services/aiTutor/domain').TutorProcessingState} [input.processingState]
 * @param {Object|null} [input.pendingTurn] store `aiTutor.pendingStudentTurn`
 * @returns {'question'|'image'|'preparing'|'reconnecting'}
 */
const PREPARING_STAGES = ['preparing', 'answering']

export function deriveThinkingPhase(input) {
  const { streamStatus, processingState, pendingTurn } = input || {}
  if (streamStatus === 'reconnecting') return THINKING_PHASE.RECONNECTING
  if (
    processingState &&
    processingState.phase === 'processing' &&
    PREPARING_STAGES.includes(processingState.stage)
  ) {
    return THINKING_PHASE.PREPARING
  }
  if (pendingTurn && pendingTurn.image) {
    return THINKING_PHASE.IMAGE
  }
  return THINKING_PHASE.QUESTION
}
